import React, { useEffect, useState } from 'react';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { FinalCTA } from './components/FinalCTA';
import { HomePage } from './pages/HomePage';
import { HumanCapabilityPage } from './pages/HumanCapabilityPage';
import { SemanticKnowledgePage } from './pages/SemanticKnowledgePage';
import { CJIPage } from './pages/CJIPage';
import { NCJIPage } from './pages/NCJIPage';
import { SolutionsPage } from './pages/SolutionsPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { AboutPage } from './components/AboutPage';
import { ResearchPage } from './pages/ResearchPage';
import { RoadmapPage } from './pages/RoadmapPage';
import { InvestPage } from './pages/InvestPage';
import { LlmVsSkpPage } from './pages/LlmVsSkpPage';
import { NoetivraPage } from './pages/NoetivraPage';
import { NoetivraDemoCenterPage } from './pages/NoetivraDemoCenterPage';
import { PartnershipsPage } from './pages/PartnershipsPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './components/PrivacyPolicyPage';
import { TermsOfServicePage } from './components/TermsOfServicePage';
import { GovernmentPage } from './pages/applications/GovernmentPage';
import { EducationPage } from './pages/applications/EducationPage';
import { EmployersPage } from './pages/applications/EmployersPage';
import { CivilSocietyPage } from './pages/applications/CivilSocietyPage';
import { LeadershipPage } from './pages/applications/LeadershipPage';
import { PillarPage } from './pages/PillarPage';
import { legacyCapabilityRedirects, pillarHref, pillars } from './data/pillars';
import { ScalePage } from './pages/ScalePage';
import { CognocracyPage } from './pages/projects/CognocracyPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { GovernmentDemoPage } from './pages/demos/GovernmentDemoPage';
import { ResearchDemoPage } from './pages/demos/ResearchDemoPage';
import { DevelopmentDemoPage } from './pages/demos/DevelopmentDemoPage';
import { ClinicalDemoPage } from './pages/demos/ClinicalDemoPage';
import { applyPageMeta } from './utils/pageMeta';
type RouteConfig = {
  page: React.ComponentType;
  withCTA: boolean;
  /** Demo workspaces render full-screen, without the site header and footer. */
  layout?: 'demo';
};
const routes: Record<string, RouteConfig> = {
  '/': {
    page: HomePage,
    withCTA: false
  },
  '/human-capability': {
    page: HumanCapabilityPage,
    withCTA: false
  },
  '/semantic-knowledge': {
    page: SemanticKnowledgePage,
    withCTA: false
  },
  '/llm-vs-skp': {
    page: LlmVsSkpPage,
    withCTA: false
  },
  '/noetivra': {
    page: NoetivraPage,
    withCTA: false
  },
  '/noetivra/demo-center': {
    page: NoetivraDemoCenterPage,
    withCTA: false
  },
  '/cji': {
    page: CJIPage,
    withCTA: true
  },
  '/ncji': {
    page: NCJIPage,
    withCTA: true
  },
  '/solutions': {
    page: SolutionsPage,
    withCTA: false
  },
  '/about': {
    page: AboutPage,
    withCTA: false
  },
  '/research': {
    page: ResearchPage,
    withCTA: false
  },
  '/roadmap': {
    page: RoadmapPage,
    withCTA: false
  },
  '/partnerships': {
    page: PartnershipsPage,
    withCTA: false
  },
  '/investors': {
    page: InvestPage,
    withCTA: false
  },
  '/contact': {
    page: ContactPage,
    withCTA: false
  },
  '/privacy': {
    page: PrivacyPolicyPage,
    withCTA: false
  },
  '/terms': {
    page: TermsOfServicePage,
    withCTA: false
  },
  '/how-it-works': {
    page: HowItWorksPage,
    withCTA: false
  },
  '/government': {
    page: GovernmentPage,
    withCTA: false
  },
  '/education': {
    page: EducationPage,
    withCTA: false
  },
  '/employers': {
    page: EmployersPage,
    withCTA: false
  },
  '/civil-society': {
    page: CivilSocietyPage,
    withCTA: false
  },
  '/leadership': {
    page: LeadershipPage,
    withCTA: false
  },
  ...Object.fromEntries(pillars.map(pillar => [pillarHref(pillar.id), {
    page: () => <PillarPage id={pillar.id} data-id="element-0" data-mp="6ofdunwudtex" />,
    withCTA: true
  }])),
  '/individual-level': {
    page: () => <ScalePage key="individual" scale="individual" data-id="element-1" data-mp="6qs1nhpa6xzw" />,
    withCTA: true
  },
  '/organizational-level': {
    page: () => <ScalePage key="organizational" scale="organizational" data-id="element-2" data-mp="qx5jg79vv4ep" />,
    withCTA: true
  },
  '/municipal-scale': {
    page: () => <ScalePage key="municipal" scale="municipal" data-id="element-3" data-mp="m5x6j19ch0ws" />,
    withCTA: true
  },
  '/national-scale': {
    page: () => <ScalePage key="national" scale="national" data-id="element-4" data-mp="h6sy4cu8v77i" />,
    withCTA: true
  },
  '/projects': {
    page: ProjectsPage,
    withCTA: false
  },
  '/projects/cognocracy': {
    page: CognocracyPage,
    withCTA: false
  },
  '/demos/government': {
    page: GovernmentDemoPage,
    withCTA: false,
    layout: 'demo'
  },
  '/demos/research': {
    page: ResearchDemoPage,
    withCTA: false,
    layout: 'demo'
  },
  '/demos/education': {
    page: () => <DevelopmentDemoPage key="education" domain="education" data-id="element-5" data-mp="zxk3l3b42dgm" />,
    withCTA: false,
    layout: 'demo'
  },
  '/demos/talent': {
    page: () => <DevelopmentDemoPage key="talent" domain="talent" data-id="element-6" data-mp="vx061ymml7ty" />,
    withCTA: false,
    layout: 'demo'
  },
  '/demos/leadership': {
    page: () => <DevelopmentDemoPage key="leadership" domain="leadership" data-id="element-7" data-mp="3kpm9qk3gplz1" />,
    withCTA: false,
    layout: 'demo'
  },
  '/demos/community': {
    page: () => <DevelopmentDemoPage key="community" domain="community" data-id="element-8" data-mp="3gotxdhzan0yj" />,
    withCTA: false,
    layout: 'demo'
  },
  '/demos/clinical': {
    page: ClinicalDemoPage,
    withCTA: false,
    layout: 'demo'
  }
};
export function App() {
  const [path, setPath] = useState(getInitialPath);
  useEffect(() => {
    const handlePopState = () => {
      setPath(normalizePath(window.location.pathname));
      window.scrollTo(0, 0);
    };
    const handleClick = (event: MouseEvent) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      const anchor = (event.target as HTMLElement).closest('a');
      if (!anchor || anchor.target === '_blank') return;
      const rawHref = anchor.getAttribute('href');
      if (!rawHref || rawHref.startsWith('//')) return;
      // Same-page section links ("#clinical") resolve against the current page.
      const href = rawHref.startsWith('#') ? `${window.location.pathname}${rawHref}` : rawHref;
      if (!href.startsWith('/')) return;
      event.preventDefault();
      const [rawPath, hash] = href.split('#');
      const nextPath = normalizePath(rawPath);
      const nextUrl = hash ? `${nextPath}#${hash}` : nextPath;
      if (nextUrl !== window.location.pathname + window.location.hash) {
        window.history.pushState({}, '', nextUrl);
      }
      const samePage = nextPath === normalizePath(window.location.pathname);
      setPath(nextPath);
      if (hash) {
        // Wait for the destination page to render before scrolling to its section.
        window.setTimeout(() => scrollToHash(hash, samePage), samePage ? 0 : 50);
      } else {
        window.scrollTo(0, 0);
      }
    };

    // Deep links such as /noetivra#clinical opened directly.
    const initialHash = window.location.hash.slice(1);
    if (initialHash && routes[normalizePath(window.location.pathname)]) {
      window.setTimeout(() => scrollToHash(initialHash, false), 100);
    }
    window.addEventListener('popstate', handlePopState);
    document.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('popstate', handlePopState);
      document.removeEventListener('click', handleClick);
    };
  }, []);
  useEffect(() => {
    applyPageMeta(routes[path] ? path : '/');
  }, [path]);
  const route = routes[path] ?? routes['/'];
  const Page = route.page;
  if (route.layout === 'demo') {
    return <div className="font-body text-ink-dark selection:bg-lavender selection:text-white" data-id="element-9" data-mp="2zbu4yzdfjk16">
        <Page key={path} data-id="element-10" data-mp="345evy7glvdqv" />
      </div>;
  }
  return <div className="min-h-screen bg-surface-bg font-body text-ink-dark selection:bg-teal selection:text-white" data-id="element-11" data-mp="2pfh9px28ky4b">
      <Navigation data-id="element-12" data-mp="2uf3oiaxpqmf8" />
      <main data-id="element-13" data-mp="2uek50psezpz3">
        <Page data-id="element-14" data-mp="2uebrqwsdqind" />
        {route.withCTA && <FinalCTA data-id="element-15" data-mp="2gej63fvpmsm9" />}
      </main>
      <Footer data-id="element-16" data-mp="2gfc49sgls9ss" />
    </div>;
}

// Scrolls to a section, leaving room for the fixed header. Works on mobile
// browsers that ignore scroll-margin with scrollIntoView.
function scrollToHash(hash: string, smooth: boolean) {
  const target = document.getElementById(decodeURIComponent(hash));
  if (!target) {
    window.scrollTo(0, 0);
    return;
  }
  const header = document.querySelector('header');
  const offset = (header?.getBoundingClientRect().height ?? 72) + 16;
  const top = target.getBoundingClientRect().top + window.scrollY - offset;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({
    top: Math.max(top, 0),
    behavior: smooth && !reduceMotion ? 'smooth' : 'auto'
  });
}

// Renamed pages keep working at their old addresses.
const renamedPaths: Record<string, string> = {
  '/research-areas': '/roadmap',
  '/invest': '/investors',
  '/initiatives': '/projects',
  '/initiatives/cognocracy': '/projects/cognocracy',
  ...legacyCapabilityRedirects
};
function normalizePath(pathname: string) {
  const clean = pathname.replace(/\/+$/, '');
  const path = clean === '' ? '/' : clean;
  return renamedPaths[path] ?? path;
}

// Old links used "#page" addresses (e.g. /#cji). Redirect them to clean paths.
function getInitialPath() {
  const legacy = window.location.hash.slice(1);
  const onRoot = window.location.pathname === '/' || window.location.pathname === '';
  if (legacy && onRoot) {
    const legacyPath = legacy === 'home' ? '/' : `/${legacy}`;
    if (routes[legacyPath]) {
      window.history.replaceState({}, '', legacyPath);
      return legacyPath;
    }
  }
  const path = normalizePath(window.location.pathname);
  // Show the new address in the browser when an old one was opened.
  if (path !== window.location.pathname && routes[path]) {
    window.history.replaceState({}, '', path + window.location.hash);
  }
  return path;
}